// extracted by mini-css-extract-plugin
module.exports = {"project_list_checkbox_column":"ProjectManagementItem_project_list_checkbox_column__3Pulz","wrap_column":"ProjectManagementItem_wrap_column__1Q7ch"};